/**
 * ArticleActs
 * Inserts dezente Roman-numeral act markers before logical H2 sections in
 * the article body. Mapping is content-aware via H2 heading text matching.
 *
 * If a heading isn't found, the marker is skipped silently — no breakage.
 */

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

/**
 * Act definitions: each entry has a roman numeral and a list of substring
 * matchers (case-insensitive) — the first H2 whose text starts with any
 * matcher gets the marker.
 */
const ACTS = [
	{ act: 1, label: 'Akt I — Problem',          matchers: ['mehr zeit fürs aufräumen', 'aufräumen', 'warum mein code', 'jeden montag'] },
	{ act: 2, label: 'Akt II — Definition',      matchers: ['was ist compound', 'compound engineering', 'definition'] },
	{ act: 3, label: 'Akt III — Architektur',    matchers: ['eine schicht trägt nicht', 'truth-architektur', 'architektur'] },
	{ act: 4, label: 'Akt IV — Capabilities',    matchers: ['capabilities', 'agentic-engineering-gold', 'brownfield'] },
	{ act: 5, label: 'Akt V — Praxis',           matchers: ['wann es nicht funktioniert', 'nachbauen', 'gegenargumente', 'wann nicht', 'praxis'] },
];

export default class ArticleActs {
	constructor(bodySelector = '[data-article-body]') {
		this.body = document.querySelector(bodySelector);
		if (!this.body) return;
		this.inject();
	}

	inject() {
		const headings = Array.from(this.body.querySelectorAll('h2'));
		if (!headings.length) return;

		const used = new Set();

		ACTS.forEach(({ act, label, matchers }) => {
			const heading = headings.find((h) => {
				if (used.has(h)) return false;
				const text = (h.textContent || '').toLowerCase().trim();
				return matchers.some((m) => text.includes(m.toLowerCase()));
			});

			if (!heading) return;
			used.add(heading);

			const marker = document.createElement('span');
			marker.className = 'article-act-marker';
			marker.setAttribute('aria-hidden', 'true');
			marker.textContent = label;

			heading.classList.add('has-act-marker');
			heading.parentNode.insertBefore(marker, heading);
		});

		// If no acts matched at all, fall back to marking ~every 2nd H2
		if (used.size === 0 && headings.length >= 4) {
			const step = Math.max(1, Math.floor(headings.length / 5));
			headings.forEach((h, i) => {
				if (i % step !== 0) return;
				const actNum = Math.floor(i / step) + 1;
				if (actNum > ROMAN.length) return;
				const marker = document.createElement('span');
				marker.className = 'article-act-marker';
				marker.setAttribute('aria-hidden', 'true');
				marker.textContent = `Akt ${ROMAN[actNum - 1]}`;
				h.classList.add('has-act-marker');
				h.parentNode.insertBefore(marker, h);
			});
		}
	}
}
